import React from 'react'
import { buttonStyles } from './Button'

export const AnchorButton = props => <a css={buttonStyles} {...props} />
